import { IFacetteFiltre } from './IFacette';
import { ISearchLimitOffset } from './ISearchLimitOffset';

export interface IFilterNotice extends ISearchLimitOffset {
    Collection?: string;
    Auteur?: string;
    Titre?: string;
    EanIsbn?: string;
    SortField?: string;
    IsDescending?:boolean;
    FacettesFiltre?:IFacetteFiltre[];
    SocieteIds?: number [];
  }

 
  export const getDefaultFilterNotice = (): IFilterNotice => ({
    Collection:"",
    Auteur:"",
    Titre: "",
    EanIsbn: "",
    Offset: 0,
    Limit: 10,
    SortField: "",
    IsDescending: true,
    FacettesFiltre:[],
    SocieteIds :[],
  });

  export const dtoToFilter = (dto: IFilterNotice): IFilterNotice => {
  
    return {
      Collection: dto.Collection,
      Auteur: dto.Auteur,
      Titre: dto.Titre,
      EanIsbn: dto.EanIsbn,
      Limit: dto.Limit !== undefined ? dto.Limit : 10,
      Offset: dto.Offset !== undefined ? dto.Offset : 0,
      IsDescending: dto.IsDescending !== undefined ? dto.IsDescending : false,
      SortField: dto.SortField,
      FacettesFiltre: dto.FacettesFiltre !== undefined ? dto.FacettesFiltre : [],
      SocieteIds: dto.SocieteIds !== undefined ? dto.SocieteIds : [],
    };
  };
  
  export const filterToQuery = (filter: IFilterNotice): IFilterNotice => {
    const dto: IFilterNotice = {};
 
    if (filter?.Collection !== undefined ) {
      dto.Collection = filter.Collection;
    } 

    if (filter?.Auteur !== undefined ) {
      dto.Auteur = filter.Auteur;
    } 

    if (filter?.Titre !== undefined ) {
      dto.Titre = filter.Titre;
    } 

    if (filter?.EanIsbn !== undefined ) {
      dto.EanIsbn = filter.EanIsbn;
    } 


    ///...

    if (filter?.FacettesFiltre !== undefined ) { // ??
      dto.FacettesFiltre = filter.FacettesFiltre;
    } 
    if (filter?.SocieteIds !== undefined ) { // ??
      dto.SocieteIds = filter.SocieteIds;
    } 


    if (filter?.Limit) {
      dto.Limit = filter.Limit;
    } else {
      dto.Limit = 10;
    }
    if (filter?.Offset) {
      dto.Offset = filter.Offset;
    } else {
      dto.Offset = 0;
    }
  
    if (filter?.IsDescending) {
      dto.IsDescending = filter.IsDescending;
    } else {
      dto.IsDescending = false;
    }
  
    if (filter?.SortField) {
      dto.SortField = filter.SortField;
    } else {
      dto.SortField = "";
    }

    localStorage.setItem("IFilterNotices", JSON.stringify(dto));
  
    return dto;
  };
  
  
 